// extracted by mini-css-extract-plugin
module.exports = {"main":"DropDownMenu_main__1WRhY","header":"DropDownMenu_header__1vq4K","dropdownImage":"DropDownMenu_dropdownImage__2S63z","children":"DropDownMenu_children__2-aNl"};